;(function (angular) {
   'use strict'

   angular.module('azure.barcodeScanner', []).factory('barcodeScanner', barcodeScanner)

   function barcodeScanner(pubSub) {
      //================================================================================
      // Events
      //================================================================================

      const _events = Object.freeze({
         barcodeScanned: 'barcode:scanned',
      })

      function barcodeScanned(args) {
         return pubSub.publish(_events.barcodeScanned, args)
      }

      //================================================================================

      const _maxDelayBetweenKeypresses = 200
      let _currentBuffer = ''
      let _scanTimeout
      const _barcodeRegex = /\d{12,13}/g

      function checkScan() {
         const match = _currentBuffer.match(_barcodeRegex)
         _currentBuffer = ''
         if (match) {
            barcodeScanned({scannedCode: match[0], featurePath: 'scanner'})
         }
      }

      function keypress(e) {
         _currentBuffer += e.key
         clearTimeout(_scanTimeout)
         _scanTimeout = setTimeout(checkScan, _maxDelayBetweenKeypresses)
      }

      document.addEventListener('keypress', keypress)

      //================================================================================

      return {
         barcodeScanned: barcodeScanned,
         // Events
         events: _events,
         subscribe: pubSub.subscribe,
      }
   }
})(angular)
